export const baseURL = "https://carmel-conscionable-nondevotionally.ngrok-free.dev/v1/";
export const rootURL = "https://carmel-conscionable-nondevotionally.ngrok-free.dev";
export const baseUrlGateway = "http://192.168.1.129:3001/v1/";
export const baseExportURL = "http://192.168.1.129:3001/v1/";

